var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32194_9130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.418 6.66536C8.20964 6.66536 6.20964 7.49036 4.66797 8.83203L1.66797 5.83203V13.332H9.16797L6.1513 10.3154C7.30964 9.3487 8.78464 8.7487 10.418 8.7487C13.368 8.7487 15.8763 10.6737 16.7513 13.332L18.7263 12.682C17.568 9.19036 14.293 6.66536 10.418 6.66536Z",
    fill: "#DC3545"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32194_9130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedUndo);
export default __webpack_public_path__ + "static/media/red_undo.20cdfdbf91683cff0437123e450a44f6.svg";
export { ForwardRef as ReactComponent };